export const AccClientConfig = {
  vehicleIsBoat: false,
  showsFaq: true
};
